import React from 'react';
import classNames from 'clsx';
import Done from '@material-ui/icons/Done';
import InputAdornment from '@material-ui/core/InputAdornment';
import Fade from '@material-ui/core/Fade';

import { DoneAdornmentProps } from './DoneAdornment.interface';
import { useStyles } from './DoneAdornment.styles';

export default function DoneAdornment({ className }: DoneAdornmentProps) {
  const classes = useStyles();

  return (
    <Fade in>
      <InputAdornment
        disablePointerEvents
        position="start"
        className={classNames(classes.root, className)}
      >
        <Done />
      </InputAdornment>
    </Fade>
  );
}
